export default "__VITE_ASSET__nL4oeO$P__"